import type { Lesson } from "./types";

export interface LessonTranslations {
  source: string;
  translations: Record<string, string>;
}

export function lessonTranslationSource(lesson: Lesson): string {
  return JSON.stringify({
    title: lesson.title,
    context: lesson.sourceText,
    sentences: lesson.segments.filter((segment) => segment.segmentType === "sentence")
      .map(({ id, text }) => ({ id, text }))
  });
}
